import React from 'react'
import Main from "./Main";
import About from "./About";
import Custom from "./Custom";

const Home = () => {
    return (
        <>
        <Main />
        <About />
        <Custom />
        </>
    )
}

export default Home
